import { styled } from 'styled-components';

import FormModal from 'src/components/general-ui/FormModal';

export const StyledModal = styled(FormModal)``;
